import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { exchangeSession } = useAuth();
  const [status, setStatus] = useState("Signing you in…");
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        await exchangeSession(sessionId);
        window.history.replaceState({}, "", window.location.pathname);
        toast.success("Welcome to Vyrti");
        navigate("/", { replace: true });
      } catch (e) {
        toast.error("Sign-in failed. Try again.");
        navigate("/login", { replace: true });
      }
    })();
  }, [exchangeSession, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F7F7]">
      <div className="text-center">
        <div className="w-12 h-12 rounded-full border-4 border-zinc-200 border-t-[#0654BA] animate-spin mx-auto" />
        <p className="mt-4 text-sm text-zinc-500" data-testid="auth-callback-status">{status}</p>
      </div>
    </div>
  );
}
